<section>
    <div [class]="isPddj ? 'help-page pddj-height' : 'help-page'">
        <p>
            Our support team can be reached via phone or email Monday through Friday from 8am to 8pm and Saturdays from 10am to 6pm (all times Eastern),
            excluding holidays. For critical issues when support is closed (i.e. those that prevent you from using the application or closing a deal), complete
            the form below and the message will be forwarded to our on-call team.
        </p>
        <p class="consulting-session">
            We offer consulting sessions to maximize the benefits of EZ DOCS.
            <b
                ><a
                    class="no-underline"
                    href="https://outlook.office365.com/owa/calendar/EZDOCSConsultation30Minutes@unitedigital.com/bookings/"
                    target="_blank"
                    >Click here to schedule one</a
                ></b
            >.
        </p>

        <div class="info-row">
            <div class="contact">
                <h1>
                    <mat-icon>support_agent</mat-icon>
                    Contact Technical Support
                </h1>
                <p>
                    Phone: <a class="no-underline">{{ supportPhone }}</a>
                </p>
                <p class="email">
                    Email:
                    <a class="no-underline">{{ supportEmail }}</a>
                </p>
            </div>

            <div class="agreements">
                <h1>
                    <mat-icon>find_in_page</mat-icon>
                    Useful Information
                </h1>
                <div class="agreement-links">
                    <a class="no-underline" (click)="routeToGetStarted()">Getting Started Guide</a>
                    <a class="no-underline" (click)="routeToFTC()">FTC Safeguards Rule Compliance Summary</a>
                    <a class="no-underline" (click)="systemDocumentDialog('Release Notes')">Release Notes</a>
                </div>
            </div>
        </div>

        <div class="message">
            <h1>
                <mat-icon>mail</mat-icon>
                Leave Us A Message
            </h1>
            <form [formGroup]="helpForm" (ngSubmit)="sendMessage()">
                <div class="split-fields">
                    <div class="name-input">
                        <mat-form-field style="width: 100%" class="col message-field" appearance="fill">
                            <mat-label>First Name</mat-label>
                            <input class="form-control message-input" matInput formControlName="firstName" readonly />
                        </mat-form-field>
                    </div>

                    <div class="last-name-input">
                        <mat-form-field style="width: 100%" class="col" appearance="fill">
                            <mat-label>Last Name</mat-label>
                            <input class="form-control message-input" matInput formControlName="lastName" />
                        </mat-form-field>
                    </div>
                </div>

                <div class="split-fields">
                    <div class="email-input">
                        <mat-form-field style="width: 100%" class="col" appearance="fill">
                            <mat-label>Email</mat-label>
                            <input class="form-control message-input" matInput formControlName="email" />
                        </mat-form-field>
                    </div>
                    <div class="callback-input">
                        <mat-form-field style="width: 100%" class="col" appearance="fill">
                            <mat-label>Callback Number</mat-label>
                            <input class="form-control message-input" maxlength="50" matInput formControlName="callback" />
                        </mat-form-field>
                    </div>
                </div>

                <mat-form-field style="width: 100%">
                    <mat-label>Subject</mat-label>
                    <mat-select formControlName="subject" [value]="selectedSubject">
                        <mat-option *ngFor="let email of prefixedSubjects" [value]="email"
                            >{{ isTimeSensitiveCheck ? 'TIME SENSITIVE: ' + email : email }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="align-check">
                    <mat-checkbox formControlName="isTimeSensitive">This issue is time sensitive.</mat-checkbox>
                </div>

                <mat-form-field style="width: 100%" class="col">
                    <mat-label>For faster service, please include the Jacket ID and Form Name (where applicable).</mat-label>
                    <mat-placeholder>For faster service, please include the Jacket ID and Form Name (where applicable).</mat-placeholder>
                    <textarea
                        style="resize: none; padding: 7px 25px; width: 94%"
                        class="form-control input message-input send-message"
                        type="first-name"
                        matInput
                        minlength="5"
                        maxlength="300"
                        formControlName="message"
                    >
                    </textarea>
                    <mat-error>Message must be a minimum of 5 characters and no more than 300 chars</mat-error>
                </mat-form-field>

                <div class="submit-btn-wrap">
                    <button mat-raised-button class="form-submit-btn" type="submit">Send Message</button>
                </div>
            </form>
        </div>

        <!-- <div class="faq">
            <h1>
                <mat-icon>help</mat-icon>
                Frequently Asked Questions
            </h1>
            <div class="faq-container">
                <div class="first-set">
                    <mat-expansion-panel *ngFor="let faq of faqList" class="mat-pannel">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ faq.faqQuestion }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>{{ faq.faqAnswer }}</p>
                    </mat-expansion-panel>
                </div>
            </div>
        </div> -->
    </div>
</section>
<ddj-spinner *ngIf="isLoading"></ddj-spinner>
